import { Inject, Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, of, throwError } from 'rxjs';
import { ENVIRONMENT_CONFIG } from '../tokens';
import { EnvironmentConfig } from '../types';
import { getCurrentEnvironment } from '../env-util';

const ALLOWED_ISSUERS = {
  'https://secure.signinpreview.spglobal.com/oauth2/spglobal': {
    envs: ['dev', 'staging'],
  },
  'https://secure.signin.spglobal.com/oauth2/spglobal': {
    envs: ['prod'],
  },
};

@Injectable()
export class AuthorizationService {
  private readonly jwtHelper = new JwtHelperService();

  constructor(
    @Inject(ENVIRONMENT_CONFIG) private readonly config: EnvironmentConfig
  ) { }

  validateToken(token: string): Observable<any> {
    if (!token) {
      return throwError({ message: 'No token found' });
    }

    const decoded = this.jwtHelper.decodeToken(token);
    const isExpired = this.jwtHelper.isTokenExpired(token);

    if (!decoded || isExpired) {
      return throwError({ message: 'Token is invalid or expired' });
    }

    const issuer = decoded.iss;
    const allowedIssuer = ALLOWED_ISSUERS[issuer];

    if (
      !allowedIssuer?.envs?.includes(
        this.config.northstar.env || getCurrentEnvironment()
      )
    ) {
      return throwError({ message: 'Issuer not allowed in this environment' });
    }

    return of(true);
  }
}
